// extracted by mini-css-extract-plugin
export default {"pagination__top":"SortByNum_pagination__top__UdhT3"};